import { z } from 'zod';

export const DealPropsSchema = z.object({
  external_id: z.string().optional(),
  name: z.string().min(1, 'Name is required'),
  stage: z.string().min(1, 'Stage is required'),
  deal_type: z.string().optional(),
  investment_type: z.string().optional(),
  round: z.string().optional(),
  target_investment: z.number().positive().optional(),
  proposed_valuation: z.number().positive().optional(),
  expected_close_date: z.string().optional(),
  owner_user_id: z.string().uuid().optional(),
  source: z.string().optional(),
  source_detail: z.string().optional(),
});

export type DealProps = z.infer<typeof DealPropsSchema>;
